import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-user-mangement-menu',
  templateUrl: './user-mangement-menu.component.html',
  styleUrls: ['./user-mangement-menu.component.scss']
})
export class UserMangementMenuComponent {
  @Input() selectedMenu: 'user' | 'role' = 'user';
  @Output() selectedMenuChange = new EventEmitter<'user' | 'role'>();

  setMenu(menu: 'user' | 'role') {
    this.selectedMenu = menu;
    this.selectedMenuChange.emit(menu);
  }
}
